<template>
    <div v-if="cabinType === rate.type && currentRate === rate.rateCode">
        <div
            class="availablerates"
            v-on:click="selectRate(rate)"
            :class="{
                rateselected:
                    selectedRate.rateID === rate.rateID &&
                    selectedRate.rate === rate.rate,
            }"
        >
            <div class="availableratesinfo">
                <div
                    class="availableratesprijs darkblue"
                    v-if="selectedRate.rateID === rate.rateID"
                >
                    <font-awesome-icon icon="check-circle" />
                </div>
                <div v-else class="availableratesprijs darkblue">
                    &euro; {{ rate.prijs }},- p. p.
                </div>

                <b>{{ cabin.naam }} {{ rate.cabinCode }} </b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CabinRate',
    props: {
        rate: Object,
        index: Number,
        cabinIndex: Number,
        cabinType: String,
        currentRate: String,
        rateIndex: Number,
        selectedRate: Object,
        showAll: Boolean,
    },
    computed: {
        cabin: function() {
            let cabin = this.$store.getters.cabinDetail(this.rate.cabinCode)
            if (cabin === null) {
                console.log(
                    'Missing cabin for rate: ' + JSON.stringify(this.rate)
                )
            }
            return cabin
        },
        rateName: function() {
            return this.$store.getters.rateName(this.rate.rateCode)
        },
        rateCode: function() {
            return this.$store.getters.rateCode(this.rate.rateCode)
        },
    },
    methods: {
        selectRate: function(rate) {
            this.$store.commit('changeCabinRate', {
                cabinSetupIndex: this.cabinIndex - 1,
                rateSelectIndex: this.index,
                rate: rate.rateCode,
                rateCode: this.rateCode,
                route: this.$route,
            })
        },
    },
}
</script>

<style scoped>
.availablerates {
    padding: 1px;
    border: 1px solid #f4fcfe;
    display: flex;
    cursor: pointer;
}
.hide {
    display: none;
}
.availablerates .availableratesinfo {
    display: inline-block;

    padding: 10px;
    line-height: 42px;
    width: calc(100% - 20px);
    float: left;
}
span {
    font-size: 12px;
}
.availablerates .availableratesprijs {
    width: 114px;
    height: 40px;
    text-align: right;
    font-size: 14px;
    float: right;
    margin-right: 0;
    padding-right: 10px;
    display: inline-block;
    font-weight: bold;
}
.rateselected,
.availablerates:hover {
    background: #37b5d3;
    border: 1px solid #37b5d3;
}
.rateselected div,
.availablerates:hover div {
    color: white !important;
}
@media screen and (min-width: 900px) {
    .availablerates {
        width: calc(100% - 40px);
    }
}
</style>
